import React from 'react'
import styled from 'styled-components'

const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;

  &:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
  }
`

const TooltipText = styled.div`
  font-weight: 200;
  visibility: hidden;
  width: 200px;
  background-color: #444448;
  color: #fff;
  text-align: center;
  padding: 5px;
  position: absolute;
  z-index: 1;
  top: 150%;
  left: 50%;
  margin-left: -100px;
  opacity: 0;
  transition: opacity 0.3s;
  overflow-wrap: break-word;
  border-radius: 2px;

  &::after {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #444448 transparent;
  }
`

function Tooltip({ children, text }) {
  return (
    <TooltipContainer>
      {children}
      {text && <TooltipText className="tooltip-text">{text}</TooltipText>}
    </TooltipContainer>
  )
}

export default Tooltip
